// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/air-masses.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/air-masses/air-masses.js';

mount([g0]);
